import { BigNumber } from "../../entities/BigNumber";
import { iChrVault } from "../interfaces/chromiaInterfaces";
import { iVault } from "../interfaces/interfaces";
import { dispatchChromiaBalances, dispatchClientInfo, getClientInfo, updateChromiaBalances } from "./chromia";

export const disconnectWallet = () => {
	/* const provider = store.getState().app.web3Provider;
	localStorage.removeItem('WEB3_CONNECT_CACHED_PROVIDER');
	if (localStorage.getItem('walletconnect') && provider && provider.disconnect){
		provider.disconnect();
	} */

	// store.dispatch({
	// 	type: appActionTypes.DISCONNECT
	// });
	// store.dispatch({
	// 	type: modalsActionTypes.DISCONNECT
	// });

}

export function getVaultInfoBN(vault: iChrVault):iVault {

	const vaultInfoBN = {
		client_depo_req: new BigNumber(vault?.client_depo_req.toString(), {currentDecimals: 18}), 
		client_depo_req_dec: vault?.client_depo_req_dec, 
		client_ft: new BigNumber(vault?.client_ft.toString(), {currentDecimals: 18}),
		client_ft_dec: vault?.client_ft_dec,
		client_wd_req: new BigNumber(vault?.client_wd_req.toString(), {currentDecimals: 18}),
		client_wd_req_dec: vault?.client_wd_req_dec,
		ft_lim: new BigNumber(vault?.ft_lim_dec.toString()),
		ft_lim_dec: vault?.ft_lim_dec,
		hedger_ft: new BigNumber(vault?.hedger_ft.toString(), {currentDecimals: 18}),
		hedger_ft_dec: vault?.hedger_ft_dec,
		name: vault.name, 
		tok: vault.tok.toString('hex')
	}

	return vaultInfoBN
}

export async function getBtcPrice() {
    
    return fetch(process.env.REACT_APP_PRICE_BACKADDR + '/price?token_name=BTC')
        .then(response => response.json())
        .catch((error) => {
			throw new Error('cant get btc price')
        })
}

export async function updateAllBalances() {
	const balances = await updateChromiaBalances();
	const clientInfo = await getClientInfo();

	if (balances)
		dispatchChromiaBalances(balances.data);

	if (clientInfo !== undefined)
		dispatchClientInfo(clientInfo);
}

